import React, { useEffect, useState } from "react";
import "../pleaseLoginModal/pleaseLoginModal.css";
import "./predictionTabs.css";
import "../timeOverModal/timeOverModal.css";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@mui/material/styles";
import { tabsClasses } from "@mui/material/Tabs";
import SponsorSlider from "../sponsorSlider/SponsorSlider";
import PreviousDayPrediction from "../previousDayPrediction/PreviousDayPrediction";
import { questions } from "../../services/FixtureApi";
import Moment from "moment";
import {
  FixtureADD,
  FixturePrepend,
  FixtureData,
  QuestionData,
} from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import PredictionBoxCurrent from "./predictionBoxes/PredictionBoxCurrent";
import NextDayPrediction from "../nextDayPrediction/NextDayPrediction";
import teamImage from "../../utilities/constants.json";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PredictionStat from "./predictionBoxes/PredictionStat";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PredictionSubmitButton from "../predictionSubmit/PredictionSubmitButton";
import { useScreenDimensions } from "../../hooks/useScreenDimensions";
import PreviousDayPredictionLoggedOut from "../previousDayPrediction/logged-out/PreviousDayWinnerLoggedOut";
import { useUpdateQuestions } from "../../hooks/useUpdateQuestions";
import SubmissionModal from "../submissionSuccess/SubmissionSuccessModal";
import { usePredictMultipleAnswers } from "../../hooks/useUpdateMultipleAnswers";
import { useSettings } from "../../hooks/useSettings";
import AnnouncementBanner from "../predictionPostponed/predictionPostponed";
import NoQuestions from "../noQuestions/NoQuestions";
import TimeOverModal from "../timeOverModal/TimeOverModal";
import { formatLabel } from "../../utilities/string";
import GoldenBallPromo from "../../mobileView/profile/components/goldenBallPromo/GoldenBallPromo";

const PredictionTabs = () => {
  const theme = useTheme();
  const [answers, setAnswers] = useState([]);
  const { predict, loading } = usePredictMultipleAnswers();

  const updateAnswers = (data, isRemove) => {
    if (!isRemove) {
      const isQuestionAnswered = answers.find(
        (item) => item.question_id === data.question_id,
      );
      if (isQuestionAnswered) {
        const updateAnswers = answers.map((item) =>
          item.question_id === data.question_id ? data : item,
        );
        setAnswers(updateAnswers);
      } else {
        setAnswers([...answers, data]);
      }
    } else {
      const updateAnswers = answers.filter(
        (item) => item.question_id !== data.question_id,
      );
      setAnswers(updateAnswers);
    }
  };

  let currentDate = Moment.utc()
    .utcOffset(teamImage.timeOffset)
    .format("YYYY-MM-DD");
  const { width } = useScreenDimensions();

  const buttonWidth = React.useMemo(() => (width - 60) / 3, [width]);
  const isLoggedIn = !!localStorage.webKey;

  const dispatch = useDispatch();
  const settings = useSettings()
  const [startDate, setStartDate] = useState(Moment().format("YYYY-MM-DD"));
  const [selectedMatchDay, setSelectedMatchDay] = useState(settings.current_group_label)
  const [flag, setFlag] = useState(1);
  const [matchDayDetails, setMatchDayDetails] = useState();
  const questionList = useSelector((state) => state.fixtures.items);
  const questionDetails = useSelector((state) => state.questionData.items);
  const [isQuestionsLoading, setIsQuestionsLoading] = useState(false);

  
  const { bulkUpdateQuestions } = useUpdateQuestions();
  
  const matchStartDays = settings?.wc_start_date
  const matchEndDays = settings?.wc_end_date
  const matchDays = settings?.match_dates

  const tournamentStartMatchDay = matchDays?.[0]?.group_label
  const tournamentEndMatchDay = matchDays?.[matchDays?.length - 1]?.group_label

  const { isAtStart, isAtEnd } = React.useMemo(() => {
    const allItems = questionList.flat();
    return {
      isAtStart: !!(tournamentStartMatchDay && allItems[0]?.group_label === tournamentStartMatchDay),
      isAtEnd: !!(tournamentEndMatchDay && allItems[allItems.length - 1]?.group_label === tournamentEndMatchDay),
    };
  }, [questionList, tournamentStartMatchDay, tournamentEndMatchDay]);


  const isPostponed = React.useMemo(()=>matchDays?.find((data)=>data?.date === startDate)?.match_status === "postponed",[matchDays,startDate])

  const totalQuestions = React.useMemo(() => {
    if (!questionDetails?.length) return 0;
    return questionDetails.filter((item) => {
      if (!item.que_time_qatar_string) return false;
      const timestamp = Moment.utc(item.que_time_qatar_string)
        .utcOffset(teamImage.timeOffset, true)
        .utc()
        .valueOf();
      return Date.now() <= timestamp;
    }).length;
  }, [questionDetails]);

  const { hasChanged, hasNew } = React.useMemo(() => {
    if (questionDetails.length < 1 || answers.length < 1) return false;

    const questions = new Map(
      questionDetails
        ?.filter?.((item) => item?.user_prediction != null)
        .map((data) => [
          data?.user_prediction.question_id,
          data.user_prediction.answer,
        ]),
    );

    let hasNew = false;
    let hasChanged = false;

    for (const { question_id, answer } of answers) {
      if (!questions.has(question_id)) {
        hasNew = true; // new id
      } else if (questions.get(question_id) !== answer) {
        hasChanged = true; // text changed
      }
    }

    return { hasNew, hasChanged };
  }, [questionDetails, answers]);

  const { questionMap: questionTimeMap, activeQuestionsExists } =
    React.useMemo(() => {
      if (!questionDetails.length)
        return { questionMap: new Map([]), activeQuestionsExists: false };

      const details = questionDetails ?? questionDetails.data

      const questionMap = new Map(
        details?.map((data) => [
          data?._id?.$oid,
          data?.que_time_qatar_string,
        ]),
      );

      // Iterate through Map
      let status = false;
      for (const [_, predictionEndTime] of questionMap) {
        const timestamp = Moment.utc(predictionEndTime)
          .utcOffset(teamImage.timeOffset, true)
          .utc()
          .valueOf();

        if (Date.now() <= timestamp) {
          status = true; // exit early if active question found
          break;
        }
      }

      return { questionMap, activeQuestionsExists: status };
    }, [questionDetails]);

  const submitShown = React.useMemo(
    () => activeQuestionsExists && Number(flag) === 1 && (hasChanged || hasNew),
    [activeQuestionsExists, flag, hasChanged, hasNew],
  );

  const [submissionModal, setSubmissionModal] = useState(null);
  const [timeOverModal, setTimeOverModal] = useState(false);

  useEffect(() => {
    getQuestions();
    setQuestionDetails();
  }, []);
  useEffect(() => {
    setQuestionDetails();
  }, [questionList]);
  function setQuestionDetails() {
    let qData = [];
    if (flag != 2) {
      questionList.map((item_data, index) => {
        item_data.map((item) => {
          qData.push(item);
        });
      });
    }

    setMatchDayDetails(qData);
  }

  function getQuestions() {
    const tournamentEndMatchDay = settings?.wc_end_date
    const todayDate = Moment().format("YYYY-MM-DD")
    const finalMatchDate = settings?.match_dates?.[settings?.match_dates?.length - 1]?.date
    const date = Moment(tournamentEndMatchDay, "YYYY-MM-DD") < Moment(todayDate, "YYYY-MM-DD") ? finalMatchDate : undefined
    // If the tournament has ended, fetch questions for the final match date

    questions()
      .then((res) => {
        let data = res.data.data;

        if (data.length) {
          let items = [];

          items = res.data.data.find(
            (item) => item.group_label === settings.current_group_label,
          );


          if (items == undefined) {
            if (res.data.data[0]["data_flag"] == 2) {
              items = res.data.data[0];
            } else {
              items = res.data.data[0]["data"];
            }

            setStartDate(res.data.data[0]["date"]);
            setFlag(res.data.data[0]["data_flag"]);
          } else {
            setStartDate(items["date"]);
            setFlag(items["data_flag"]);
            if (items["data_flag"] != 2) {
              items = items.data;
            }
          }

          const answers = items
            ?.filter?.((item) => item?.user_prediction != null)
            ?.map((item) => ({
              fixture_id: item.fixture._id.$oid,
              question_id: item.user_prediction.question_id,
              answer: item.user_prediction.answer,
            }));

          dispatch(FixtureData(res.data.data));
          dispatch(QuestionData(items));
          setAnswers(answers || []);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function getQuestionList(questionList) {
    // if (matchDayDetails == undefined)
    // {
    let details = [];
    questionList.map((item_data, index) => {
      item_data.map((item) => {
        details.push(item);
      });
    });
    // }

    return details.map((item, key) => {
      let span = "";

      if (!localStorage.webKey) {
        if (item.data_flag == 1)
          span = `${item?.count} Question${item?.count === 1 ? "" : "s"}`;
        else {
          span = `${item?.count} Game${item?.count === 1 ? "" : "s"}`;
        }
      } else {
        if (item.data_flag == 1) {
          const awsrData = item.data.find((val) => val.answer_updated == 1);
          if (awsrData != undefined)
            span = `${item?.count} Point${item?.count === 1 ? "" : "s"}`;
          else span = `${item?.count} Question${item?.count === 1 ? "" : "s"}`;
        } else if (item.data_flag == 2)
          span = `${item?.count} Point${item?.count === 1 ? "" : "s"}`;
        else {
          span = `${item?.count} Game${item?.count === 1 ? "" : "s"}`;
        }
      }

      const matchDate = Moment(item?.date, "YYYY-MM-DD");
      const shortMatchDate = Moment(item?.date, "YYYY-MM-DD").format?.(
        "MMM DD",
      );
      const weekday = Moment(matchDate).format("ddd").toUpperCase();

      const date = `${shortMatchDate}, ${weekday}`;

      let textSample = (
        <p className="label-p-content">
          {formatLabel(item?.group_label)}
          <br /> <span className="label-p-span-content">{span}</span>
        </p>
      )

if(!item.group_label)return;

      return (
        <Tab
          key={key}
          className="tabs-here"
          style={{ width: buttonWidth }}
          label={textSample}
          value={item.group_label}
          onClick={() => activatePredictionBox(item, item.data_flag)}
        />
      );
    });
  }

  function activatePredictionBox(items, flag) {
    const data = flag != 2 ? items.data : items;

    const answers = data
      ?.filter?.((item) => item?.user_prediction != null)
      ?.map((item) => ({
        fixture_id: item.fixture._id.$oid,
        question_id: item.user_prediction.question_id,
        answer: item.user_prediction.answer,
      }));
    setAnswers(answers || []);
    dispatch(QuestionData(data));
    setStartDate(items.date);    
    setSelectedMatchDay(items.group_label)
    setFlag(flag);
  }

  const bulkUpdate = React.useCallback(() => {
    if (!localStorage.webKey) {
      setAnswers([]);
      return;
    }

    const now = Date.now();
    const activeAnswers = answers.filter((answer) => {
      const endTime = questionTimeMap.get(answer.question_id);
      if (!endTime) return false;
      const timestamp = Moment.utc(endTime)
        .utcOffset(teamImage.timeOffset, true)
        .utc()
        .valueOf();
      return now <= timestamp;
    });

    if (!activeAnswers.length) {
      setAnswers([]);
      setTimeOverModal(true);
      return;
    }

    predict(activeAnswers, {
      onSuccess: (res) => {
        bulkUpdateQuestions(activeAnswers);
        setSubmissionModal({
          visible: true,
          total: totalQuestions,
          answered: activeAnswers.length,
        });
      },
    });
  }, [answers, totalQuestions, questionTimeMap]);

  // useEffect(() => {
  //   if (answeredCount === totalQuestions && totalQuestions > 0) {
  //     toast.success("✅ All questions answered successfully!", {
  //       position: "top-center",
  //       autoClose: 3000,
  //     });
  //   }
  // }, [answeredCount, totalQuestions]);
  function getPredictionBox() {
    let date = Moment.utc(startDate)
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DD");
    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DD");
    let details = [];

    if (questionDetails?.length || flag == 2) {
      if (flag == 1) {
        details = questionDetails;
        // details = questionDetails.sort((a, b) =>
        //   Moment(b.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss") <
        //   Moment(a.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss")
        //     ? 1
        //     : -1
        // );

        // details=questionDetails
        let count = details.length;
        let expiry_arr = [];
        let new_arr = [];
        details.map((item, index) => {
          if (
            new Date(
              Date.parse(
                Moment(item.que_time_qatar_string).format(
                  "YYYY-MM-DDTHH:mm:ss",
                ),
              ),
            ).getTime() <
            new Date(
              Date.parse(
                Moment.utc()
                  .utcOffset(teamImage.timeOffset)
                  .format("YYYY-MM-DDTHH:mm:ss"),
              ),
            ).getTime()
          ) {
            expiry_arr.push(item);
          } else {
            new_arr.push(item);
          }
        });
        let mergedetails = [];
        if (count != expiry_arr.length) {
          mergedetails = [...new_arr, ...expiry_arr];

          details = mergedetails;
        }
      } else {
        details = questionDetails;
      }

      console.log("details", questionDetails);

      if (new Date(date).getTime() < new Date(currentDate).getTime()) {
        if (flag == 2) {
          if (!isLoggedIn)
            return (
              <PreviousDayPredictionLoggedOut
                key={1}
                leaderboard={details?.leader_board?.[0]?.winners}
                question={details}
                index={1}
              />
            );

          return <PreviousDayPrediction key={1} question={details} index={1} />;
        } else {
          return details.map((items, index) => {
            return (
              <PredictionBoxCurrent
                key={index}
                isPostponed={isPostponed}
                question={items}
                index={index}
                updateAnswers={updateAnswers}
              />
            );
          });
        }
      } else if (new Date(date).getTime() == new Date(currentDate).getTime()) {
        if (flag == 1) {
          return details.map((items, index) => {
            return (
              <PredictionBoxCurrent
                key={index}
                isPostponed={isPostponed}
                question={items}
                index={index}
                updateAnswers={updateAnswers}
              />
            );
          });
        } else if (flag == 3) {
          return (
            <NextDayPrediction
              matchData={details}
              matchNumber={details.length}
            />
          );
        } else if (flag == 2) {
          return <PreviousDayPrediction key={1} question={details} index={1} />;
        }
      } else if (new Date(date).getTime() > new Date(currentDate).getTime()) {
        if (flag == 1) {
          return details.map((items, index) => {
            return (
              <PredictionBoxCurrent
                key={index}
                question={items}
                index={index}
                updateAnswers={updateAnswers}
                isPostponed={isPostponed}
              />
            );
          });
        } else {
          return (
            <NextDayPrediction
              matchData={details}
              matchNumber={details.length}
            />
          );
        }
      }
    } else {
      return <NoQuestions />;
    }
  }
  let textSample = (
    <p className="label-p-content">
      NOV 20 <br /> <span className="label-p-span-content"> 3 MATCHES</span>
    </p>
  );
  function leftButton(e, prop) {
    e.preventDefault();
    if (!prop.disabled || isQuestionsLoading || isAtStart) return;

    const allItems = questionList.flat();
    const firstGroupLabel = allItems[0]?.group_label;
    if (!firstGroupLabel) return;

    setIsQuestionsLoading(true);
    questions({ group_label: firstGroupLabel, date_type: 2 })
      .then((res) => {
        if (res.data.data?.length) {
          const data = res.data.data?.reverse() ?? []
          dispatch(FixturePrepend(data));
          const item = data[data.length - 1];
          activatePredictionBox(item, item.data_flag);
        }
      })
      .catch(console.error)
      .finally(() => setIsQuestionsLoading(false));
  }

  function rightButton(e, prop) {
    e.preventDefault();
    if (!prop.disabled || isQuestionsLoading || isAtEnd) return;

    const allItems = questionList.flat();
    const lastGroupLabel = allItems[allItems.length - 1]?.group_label;
    if (!lastGroupLabel) return;

    setIsQuestionsLoading(true);
    questions({ group_label: lastGroupLabel, })
      .then((res) => {
        if (res.data.data?.length) {
          const data = res.data.data ?? []
          dispatch(FixtureADD(data));
          const item = data[0];
          activatePredictionBox(item, item.data_flag);
        }
      })
      .catch(console.error)
      .finally(() => setIsQuestionsLoading(false));
  }

  return (
    <div className="predictionTabs" style={{ padding: 0 }}>
      <TabContext value={selectedMatchDay}>
        <Tabs
          value={selectedMatchDay}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="scrollable force tabs example"
          TabIndicatorProps={{
            style: {
              display: "none",
            },
          }}
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
          ScrollButtonComponent={(props) => {
            if (props.direction === "left") {
              return (
                <div {...props}>
                  <button
                    className="tabSelection-leftArrow-btn"
                    disabled={isQuestionsLoading || (isAtStart && props.disabled)}
                    onClick={(e) => leftButton(e, props)}
                  >
                    <KeyboardArrowLeftIcon className="arrow-icon" />
                  </button>
                </div>
              );
            } else if (props.direction === "right") {
              return (
                <div {...props}>
                  <button
                    className="tabSelection-rightArrow-btn"
                    disabled={isQuestionsLoading || (isAtEnd && props.disabled)}
                    onClick={(e) => rightButton(e, props)}
                  >
                    <KeyboardArrowRightIcon />
                  </button>
                </div>
              );
            } else {
              return null;
            }
          }}
        >
          {questionList.length > 0
            ? getQuestionList(questionList)
            : questionList.length}

        </Tabs>

        <GoldenBallPromo/>
        {flag == 1 && questionDetails &&
          <PredictionStat question={questionDetails} matchDays={matchDays} isPostponed={isPostponed} />}
        
        <TabPanel value={selectedMatchDay} dir={theme.direction}>
          {getPredictionBox()}
        </TabPanel>
          <p className="predictionTabs-ist-note">* All match timings are based on IST (Indian Standard Time)</p>
        {submitShown && (
          <PredictionSubmitButton
            isLoading={loading}
            hasUpdates={hasChanged}
            answeredQuestions={answers?.length}
            totalQuestions={totalQuestions}
            onSubmit={bulkUpdate}
          />
        )}
        <TimeOverModal
          open={timeOverModal}
          onClose={() => setTimeOverModal(false)}
        />
        <SubmissionModal
          open={submissionModal?.visible}
          onClose={() => {
            setSubmissionModal((data) => ({ ...data, visible: false }));
            setTimeout(() => {
              setSubmissionModal(null);
            }, 150);
          }}
          totalQuestions={submissionModal?.total}
          answeredQuestions={submissionModal?.answered}
        />
        <SponsorSlider />
      </TabContext>
      <ToastContainer />
    </div>
  );
};

export default PredictionTabs;
